import { render, staticRenderFns } from "./Knowledge.vue?vue&type=template&id=7cab41fa&scoped=true&"
import script from "./Knowledge.vue?vue&type=script&lang=js&"
export * from "./Knowledge.vue?vue&type=script&lang=js&"
import style0 from "./Knowledge.vue?vue&type=style&index=0&id=7cab41fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cab41fa",
  null
  
)

export default component.exports